import { useEffect } from "react";
import { useIndexedDB } from "react-indexed-db-hook";
import SimpleReducer from "reducers/SimpleReducer";
import { useImmerReducer } from "use-immer";

const useApp = () => {
  let init = {
    settings: {
      active: false,
      show: false,
      internet: {
        online:
          navigator.onLine && localStorage.getItem("offlineMode") !== "true",
        quality: "Unknown",
      },
      autoSync: localStorage.getItem("autoSync") !== "false",
    },
  };

  const [state, dispatch] = useImmerReducer(SimpleReducer, init);

  const db = useIndexedDB("appState");
  useEffect(() => {
    if (!init.settings.internet.online) {
      db.getByID(1).then((_appState) => {
        if (_appState) {
          _appState.settings.internet.online = false;
          dispatch({ hardSet: _appState });
        } else {
          dispatch({
            key: "auth",
            value: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      });
    }
  }, []);

  return { appState: state, setAppState: dispatch };
};

export default useApp;
